/// <amd-module name="Feed/Legacy/Protocols/Maven/MavenPackagePeople" />
import * as React from "react";

import { IVssPageContext } from "VSS/Platform/Context";

import { MavenPomPerson } from "Feed/Common/Protocols/Maven/Contracts/Maven";
import * as PackageResources from "Feed/Common/Resources";
import { IPerson } from "Feed/Legacy/Protocols/Common/IPerson";
import { PackageAttribute } from "Feed/Legacy/Protocols/Components/PackageAttribute";
import { PackagePerson } from "Feed/Legacy/Protocols/Components/PackagePerson";

export interface IMavenPackagePeopleProps {
    pageContext: IVssPageContext;
    developers: MavenPomPerson[];
    contributors: MavenPomPerson[];
}

export class MavenPackagePeople extends React.PureComponent<IMavenPackagePeopleProps> {
    public render(): JSX.Element {
        if (!this.props.developers && !this.props.contributors) {
            return null;
        }

        return (
            <div className="maven-package-people">
                <PackageAttribute title={PackageResources.PackagePeople_Title}>
                    {this.props.developers.length > 0 && (
                        <div>
                            <div className="package-group-spacer" />
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.MavenPackagePeople_Developers}
                            </div>
                            {this.props.developers.map((developer: MavenPomPerson) => {
                                return (
                                    <PackagePerson
                                        pageContext={this.props.pageContext}
                                        key={developer.name}
                                        person={this.ToIPerson(developer)}
                                    />
                                );
                            })}
                        </div>
                    )}
                    {this.props.contributors.length > 0 && (
                        <div>
                            <div className="package-group-spacer" />
                            <div className="package-group-header" role="heading" aria-level={3}>
                                {PackageResources.MavenPackagePeople_Contributors}
                            </div>
                            {this.props.contributors.map((contributor: MavenPomPerson) => {
                                return (
                                    <PackagePerson
                                        pageContext={this.props.pageContext}
                                        key={contributor.name}
                                        person={this.ToIPerson(contributor)}
                                    />
                                );
                            })}
                        </div>
                    )}
                </PackageAttribute>
            </div>
        );
    }

    private ToIPerson(person: MavenPomPerson): IPerson {
        return {
            email: person.email,
            name: person.name,
            url: person.url
        } as IPerson;
    }
}
